import React from 'react';
import { View, Pressable } from 'react-native';
import { Text } from '@/components/ui/text';

interface DiscoverEmptyStateProps {
  onAction: () => void;
}

const CURATED_RESTAURANTS = [
  { name: 'Farm Bloomington', cuisine: 'American' },
  { name: 'The Irish Lion', cuisine: 'Irish Pub' },
  { name: 'Uptown Cafe', cuisine: 'American' },
  { name: 'Janko\'s Little Zagreb', cuisine: 'Eastern European' },
  { name: 'Turkuaz Cafe', cuisine: 'Turkish' },
  { name: 'Feast', cuisine: 'International' },
];

export function DiscoverEmptyState({ onAction }: DiscoverEmptyStateProps) {
  return (
    <View className="px-4 pb-4">
      <View className="bg-card rounded-xl p-6 items-center mb-6">
        <Text className="text-xl font-bold text-foreground text-center mb-2">
          Be the first to review somewhere near you
        </Text>
        <Text className="text-sm text-muted-foreground text-center mb-4">
          No one has reviewed a dish nearby yet. Explore a local restaurant and share your experience.
        </Text>
        <Pressable
          onPress={onAction}
          accessibilityLabel="Leave a Review"
          className="bg-primary rounded-lg py-3 px-6"
        >
          <Text className="text-primary-foreground text-base font-semibold">
            Leave a Review
          </Text>
        </Pressable>
      </View>

      <Text className="text-base font-semibold text-foreground mb-3">
        Popular in Bloomington
      </Text>
      <View className="gap-2">
        {CURATED_RESTAURANTS.map((restaurant) => (
          <View
            key={restaurant.name}
            className="bg-card rounded-lg px-4 py-3 flex-row justify-between items-center"
          >
            <Text className="text-sm font-medium text-foreground">{restaurant.name}</Text>
            <Text className="text-xs text-muted-foreground">{restaurant.cuisine}</Text>
          </View>
        ))}
      </View>
    </View>
  );
}
